
import MainLayout from "../../../layout/MainLayout";
import React, { useState, useEffect } from 'react';
import {ReportService} from '../../../business/ReportService';
import moment from 'moment';
import Cookies from 'universal-cookie';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import ExportToExcelFromApi from "../../../components/excel/ExportToExcelFromApi";
import { 
  Button
} from '@mui/material';


const StyledTableCell = styled(TableCell)(({ theme} :any ) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));


  const filtersInitial = {
    initalDate: null,
    finalDate: null
  }

const cookies = new Cookies();

const Reports = () => {
  

  return (
    <MainLayout>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'space-between' }}>
        <h2>Listado de Reportes</h2>
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'left' }}>

        
        
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'right' }}>

          
        </Box>
        </Box>
 
      <br></br>
      <ExportToExcelFromApi api="get-quotas" filters={filtersInitial} fileName="reporteCuotas" texto="1. Reporte de cuotas" />
  
    </MainLayout>
  )
}


export default Reports
